import type { OfferAdditionalOptionsInner } from '~/api/pricing-offers'
import { defineStore, storeToRefs } from 'pinia'
import { useOfferStore } from '~/stores/offer'

export const useExtrasStore = defineStore('extras', () => {
  const { selectedOffer } = storeToRefs(useOfferStore())

  const additionalProperties = reactive<Set<number>>(new Set())
  const coverageUpsellShown = ref(false)

  const totalExtraPrice = computed<number>(() => {
    if (selectedOffer.value?.additionalOptions === undefined)
      return 0

    return selectedOffer.value.additionalOptions
      .filter((property: OfferAdditionalOptionsInner) => additionalProperties.has(property.id!))
      .reduce((left: number, right: OfferAdditionalOptionsInner) => left + (right?.price ?? 0), 0)
  })

  function selectOrUnselectProperty(propertyId?: number) {
    if (!propertyId)
      return
    if (additionalProperties.has(propertyId))
      additionalProperties.delete(propertyId)
    else
      additionalProperties.add(propertyId)
  }

  function propertyChosen(propertyId?: number) {
    return propertyId
      ? additionalProperties.has(propertyId)
      : false
  }

  function markCoverageUpsellShown() {
    coverageUpsellShown.value = true
  }

  function reset() {
    additionalProperties.clear()
    coverageUpsellShown.value = false
  }

  return {
    additionalProperties,
    coverageUpsellShown: readonly(coverageUpsellShown),
    totalExtraPrice,
    selectOrUnselectProperty,
    propertyChosen,
    markCoverageUpsellShown,
    reset,
  }
})
